import accompagnateur_renov from 'data/parcours_data//accompagnateur_renov.json';
import chauffage from 'data/parcours_data/chauffage.json';
import conseil from 'data/parcours_data/conseil.json';
import isolation from 'data/parcours_data/isolation.json';
import renovation from 'data/parcours_data/renovation.json';
import solaire from 'data/parcours_data/solaire.json';
import thermostat from 'data/parcours_data/thermostat.json';
import audit_energetique from 'data/parcours_data/audit_energetique.json';

export default {
  ...accompagnateur_renov,
  ...chauffage,
  ...conseil,
  ...isolation,
  ...renovation,
  ...solaire,
  ...thermostat,
  ...audit_energetique,
};
